import { configureStore } from '@reduxjs/toolkit';
import editModeReducer from './features/editModeSlice';
import popoverSlice from './features/popoverSlice';
import currentSlice from './features/currentSlice';
import progressSlice from './features/progressSlice';
import snackbarSlice from './features/snackbarSlice';
import currentAppointmentSlice from './features/currentAppointmentSlice';
import logger from 'redux-logger';
// import { connectRouter, routerMiddleware } from 'connected-react-router';
import { createBrowserHistory } from 'history';
// import thunk from 'redux-thunk';
import toolbarSlice from './features/toolbarSlice';
import claimSlice from './features/claimSlice';
import invoiceSlice from './features/invoiceSlice';
import bottomBarSlice from './features/bottomBarSlice';
import notificationSlice from './features/notificationSlice';
import feeprocedureSlice from './features/feeprocedureSlice';
import tabControlSlice from './features/tabControlSlice';
import activeMedicationSlice from './features/activeMedicationSlice';
import inactiveMedicationSlice from './features/inactiveMedicationSlice';
import stateDetectorSlice from './features/stateDetectorSlice';
import quickAddDataSlice from './features/quickAddDataSlice';
import versionSlice from './features/versionChangeSlice';
import gridSlice from './features/gridSlice';
import functionalStatusSlice from './features/functionalStatusSlice';
import cognitiveStatusSlice from './features/cognitiveStatusSlice';
import showMoreReducer from './features/showMoreSlice';
export const history = createBrowserHistory();

let middleware = [];
// if (process.env.NODE_ENV === 'development') {
// if (
//   localStorage.getItem('logs') &&
//   ![0, 2, 4, 6].includes(Number(localStorage.getItem('logs')))
// ) {
//   middleware = [thunk, routerMiddleware(history), logger];
// } else {
//   middleware = [thunk, routerMiddleware(history)];
// }

if (
  localStorage.getItem('logs') &&
  ![0, 2, 4, 6].includes(Number(localStorage.getItem('logs')))
) {
  middleware = [logger];
} else {
  middleware = [];
}

const store = configureStore({
  reducer: {
    edit: editModeReducer,
    popover: popoverSlice,
    current: currentSlice,
    backdrop: progressSlice,
    snackbar: snackbarSlice,
    currentAppointmentSlice: currentAppointmentSlice,
    toolbar: toolbarSlice,
    bottombar: bottomBarSlice,
    claim: claimSlice,
    invoice: invoiceSlice,
    feeprocedures: feeprocedureSlice,
    notification: notificationSlice,
    tabController: tabControlSlice,
    stateDetector: stateDetectorSlice,
    // router: connectRouter(history),
    activeMedicationList: activeMedicationSlice,
    inactiveMedicationList: inactiveMedicationSlice,
    quickAddData: quickAddDataSlice,
    changeVersion: versionSlice,
    grid: gridSlice,
    functionalStatus: functionalStatusSlice,
    cognitiveStatus: cognitiveStatusSlice,
    showMore: showMoreReducer,
  },
  middleware: [...middleware],
});

export { store };
